import { render, staticRenderFns } from "./Internationallocation.vue?vue&type=template&id=5ad30060&"
import script from "./Internationallocation.vue?vue&type=script&lang=js&"
export * from "./Internationallocation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports